// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-0ed685da]  .bottom .buttons{display:none}", ""]);
// Exports
module.exports = exports;
